import { useState } from 'react';
import { createModel } from 'hox';
import { TablePaginationConfig } from 'antd/es/table/interface';
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE } from '@/utils/constants';
import { wbpService } from './wbpService';
import { useGlobalModel, transPgToPaginationTotal } from '@/model/globalModel';
import { convertRes2Blob } from '@/utils/exportFile';
import { ISearchPage } from '@/types/AppTypes';
import { IWbpDetail, IWbpSearchFields } from './wbpTypes';

export const useWbpModel = createModel(function () {
	const {
		user: { shopCode },
		setLoadingInfo,
	} = useGlobalModel(({ user }) => [user]);
	/**
	 * 列表
	 */
	//列表数据源
	const [dataSource, setDataSource] = useState<IWbpDetail[]>([]);
	//查询条件
	const [searchParam, setSearchParam] = useState<IWbpSearchFields>({});
	//分页参数
	const initPgCfg: TablePaginationConfig = {
		pageSize: DEFAULT_PAGE_SIZE,
		current: DEFAULT_FIRST_PAGE_NUM,
	};
	const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);
	//表格多选id值
	const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([]);
	const [loading, setLoading] = useState<boolean>(false);

	//列表查询
	const loadData = async (
		page: ISearchPage = initPgCfg,
		searchValue: IWbpSearchFields = searchParam
	) => {
		setLoading(true);
		const searchParams = {
			shopCode,
			...searchValue,
			pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
			pageNum: (page?.current || page?.pageNum) ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
		};
		let { retData } = await wbpService.page(searchParams);
		const { records, ...pg } = retData;
		setPgCfg(transPgToPaginationTotal(pg));
		setDataSource(records);
		setLoading(false);
	};
	//设置搜索value
	const updateSearchParam = (updateParam: IWbpSearchFields) => {
		setSearchParam({ ...searchParam, ...updateParam });
	};

	//重置搜索参数
	const resetSearchParam = () => {
		setSearchParam({});
		setSelectedRowKeys([]);
		loadData(initPgCfg, {});
	};

	//导出
	const exportWbp = async (searchValue: IWbpSearchFields = searchParam) => {
		setLoadingInfo({ loadingVisible: true, txt: '快速导出中' });
		try {
			const searchParams = {
				shopCode,
				...searchValue,
				singleCode: selectedRowKeys?.join(),
				pageSize: -1,
				pageNum: 1,
			};

			let result = await wbpService.export(searchParams);
			result && setLoadingInfo({ loadingVisible: false, txt: '' });
			convertRes2Blob(result);
		} catch {
			setLoadingInfo({ loadingVisible: false, txt: '' });
		}
	};

	//下载模板
	const downloadTpl = async () => {
		let result = await wbpService.downloadTpl();
		convertRes2Blob(result);
	};

	return {
		/***field***/
		searchParam,
		dataSource,
		selectedRowKeys,
		pgCfg,
		loading,
		/***method***/
		setDataSource,
		setSelectedRowKeys,
		resetSearchParam,
		updateSearchParam,
		loadData,
		exportWbp,
		downloadTpl,
	};
});
